import { BookOpen, PenSquare } from "lucide-react";
import { Link } from "react-router";
import { PRODUCTS } from "../shared/lib/products";

/**
 * `/` on a hostname that is not a docs hostname — the console's, or localhost. Each product's
 * documentation lives under its own `/docs/:product` prefix there (ADR-0046 decision 4), so the
 * root only points at them and at the consoles.
 */
export function DocsIndexPage() {
  return (
    <div className="mx-auto max-w-[720px] px-10 pb-20 pt-16">
      <h1
        className="mb-2 text-[2rem] font-bold leading-tight tracking-tight"
        style={{ color: "var(--foreground)" }}
      >
        Rigo documentation
      </h1>
      <p className="mb-8 text-lg" style={{ color: "var(--muted-foreground)" }}>
        Choose a product.
      </p>

      <div
        className="mb-10 flex flex-col overflow-hidden rounded-lg border"
        style={{ borderColor: "var(--border)" }}
      >
        {PRODUCTS.map((product) => (
          <Link
            key={product.id}
            to={`/docs/${product.id}`}
            className="flex items-center gap-3 border-b px-4 py-3.5 no-underline last:border-b-0"
            style={{ background: "var(--card)", borderColor: "var(--border)" }}
          >
            <BookOpen
              className="size-4 shrink-0"
              style={{ color: "var(--muted-foreground)" }}
              aria-hidden
            />
            <span className="flex-1 text-sm font-medium" style={{ color: "var(--foreground)" }}>
              {product.name} documentation
            </span>
          </Link>
        ))}
      </div>

      <Link
        to="/admin"
        className="inline-flex items-center gap-2 text-sm no-underline"
        style={{ color: "var(--muted-foreground)" }}
      >
        <PenSquare className="size-4" aria-hidden />
        Docs console (Rigo staff)
      </Link>
    </div>
  );
}
